import { CheckCircle2 } from "lucide-react";
import { Card, Pill, money, fmtDate } from "./ui";

const Row = ({ k, v, strong }) => (
  <div className={`flex justify-between gap-4 py-1.5 text-sm ${strong ? "font-bold text-[#0B2545] text-base" : "text-slate-700"}`}><span>{k}</span><span className="text-right">{v}</span></div>
);

export function QuoteView({ q, orgName, children }) {
  const t = q.totals;
  return (
    <Card className="p-0 overflow-hidden" data-testid={`quote-${q.id}`}>
      <div className="bg-[#0B2545] text-white px-6 py-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-xs uppercase tracking-wider text-sky-200">{q.kind === "renewal" ? "Renewal quotation" : "Quotation"} {q.ref} · version {q.version}</p>
          {orgName && <p className="font-heading text-lg font-bold">{orgName}</p>}
        </div>
        <Pill s={q.status} testid={`quote-status-${q.id}`} />
      </div>
      <div className="p-6 grid md:grid-cols-2 gap-x-10">
        <div>
          <Row k="Pricing model" v={q.model === "per_dentist_month" ? "Per dentist / month" : "Total package"} />
          <Row k={q.model === "per_dentist_month" ? "Unit price" : "Package price"} v={money(q.unit_price, q.currency)} />
          <Row k="Dentist licenses" v={q.licenses} />
          <Row k="Contract period" v={`${fmtDate(q.start)} → ${fmtDate(q.end)}`} />
          <Row k="Valid until" v={fmtDate(q.valid_until)} />
        </div>
        <div className="border-t md:border-t-0 md:border-l border-slate-200 md:pl-10 mt-4 md:mt-0">
          <Row k="Subtotal" v={money(t.subtotal, q.currency)} />
          <Row k={q.complimentary ? "Complimentary" : `Discount (${q.discount_pct}%)`} v={`− ${money(t.discount, q.currency)}`} />
          <Row k={`Tax (${q.tax_pct}%)`} v={money(t.tax, q.currency)} />
          <div className="border-t border-slate-200 mt-2 pt-2"><Row k="Total" v={<span data-testid={`quote-total-${q.id}`}>{money(t.total, q.currency)}</span>} strong /></div>
        </div>
      </div>
      {q.terms && (
        <div className="px-6 pb-4">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Terms</p>
          <ul className="mt-2 space-y-1">{q.terms.split("\n").filter(Boolean).map((x) => <li key={x} className="text-sm text-slate-700 flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" />{x}</li>)}</ul>
        </div>
      )}
      {q.accepted_by && <p className="px-6 pb-4 text-xs text-slate-500">Accepted by {q.accepted_by} on {fmtDate(q.accepted_at)}</p>}
      {children && <div className="px-6 pb-6">{children}</div>}
    </Card>
  );
}
